module.exports = __webpack_public_path__ + "img/wz-8-2-1.9bae2f6d.jpg";